export const projectStatuses = [
  'Not Started',
  'Scheduled',
  'In Progress',
  'In Progress - RFI Pending',
  'In Progress - On Site',
  'Submitted - Pending Intake',
  'Submitted - Under Review',
  'Resubmitted - Under Review',
  'Approved',
  'Approved - Partial',
  'Under construction',
  'Closeout Pending',
  'Completed',
];

export function getProjectStatus(value) {
  const status = Array.isArray(value)
    ? value.find(item => typeof item?.Status__c === 'string' && item.Status__c.trim())?.Status__c
    : value;
  if (typeof status !== 'string' || !status.trim()) return 'N/A';

  const trimmedStatus = status.trim();
  return projectStatuses.find(item => item.toLowerCase() === trimmedStatus.toLowerCase()) || trimmedStatus;
}
